<template>
  <div class="width-100">
    <h2 class="section-title">{{ $t('systemConfig.title') }}</h2>

    <div class="form-block system-config-form">
      <el-form
        ref="systemConfigForm"
        label-position="top"
        size="small"
      >
        <h2 class="section-title">{{ $t('systemConfig.printers') }}</h2>
        <div
          v-for="(printer, index) in formData.printers"
          :key="index"
        >
          <h3 class="section-subtitle">
            {{ $t(`systemConfig.${printer.type}`) }}
          </h3>
          <el-row
            :gutter="20"
            type="flex"
            style="flex-wrap: wrap"
          >
            <!-- <el-col :span="3" :lg="6" :xl="4"> -->
            <!-- <FormItem :label="$t('systemConfig.printerName')">
                <el-input v-model="formData.printers[index].config.printerName" />
              </FormItem> -->
            <!-- </el-col> -->
            <el-col
              :span="4"
              :lg="6"
              :xl="4"
            >
              <FormItem :label="$t('systemConfig.printWidth-mm')">
                <el-input
                  v-model="formData.printers[index].config['printWidth-mm']"
                  type="number"
                  min="0"
                  step="0.01"
                />
              </FormItem>
            </el-col>
            <el-col
              :span="4"
              :lg="6"
              :xl="4"
            >
              <FormItem :label="$t('systemConfig.printHeight-mm')">
                <el-input
                  v-model="formData.printers[index].config['printHeight-mm']"
                  type="number"
                  min="0"
                  step="0.01"
                />
              </FormItem>
            </el-col>
            <el-col
              :span="4"
              :lg="6"
              :xl="4"
            >
              <FormItem :label="$t('systemConfig.labelWidth-mm')">
                <el-input
                  v-model="formData.printers[index].config['labelWidth-mm']"
                  type="number"
                  min="0"
                  step="0.01"
                />
              </FormItem>
            </el-col>
            <el-col
              :span="4"
              :lg="6"
              :xl="4"
            >
              <FormItem :label="$t('systemConfig.labelHeight-mm')">
                <el-input
                  v-model="formData.printers[index].config['labelHeight-mm']"
                  type="number"
                  min="0"
                  step="0.01"
                />
              </FormItem>
            </el-col>
            <el-col
              :span="4"
              :lg="6"
              :xl="4"
            >
              <FormItem :label="$t('systemConfig.labelMarginLeft-mm')">
                <el-input
                  v-model="
                    formData.printers[index].config['labelMarginLeft-mm']
                  "
                  type="number"
                  min="0"
                  step="0.01"
                />
              </FormItem>
            </el-col>
            <el-col
              :span="4"
              :lg="6"
              :xl="4"
            >
              <FormItem :label="$t('systemConfig.labelMarginTop-mm')">
                <el-input
                  v-model="formData.printers[index].config['labelMarginTop-mm']"
                  type="number"
                  min="0"
                  step="0.01"
                />
              </FormItem>
            </el-col>
            <el-col
              :span="4"
              :lg="6"
              :xl="4"
            >
              <FormItem :label="$t('systemConfig.labelColSpacing-mm')">
                <el-input
                  v-model="
                    formData.printers[index].config['labelColSpacing-mm']
                  "
                  type="number"
                  min="0"
                  step="0.01"
                />
              </FormItem>
            </el-col>
            <el-col
              :span="4"
              :lg="6"
              :xl="4"
            >
              <FormItem :label="$t('systemConfig.showCalibrationBorder')">
                <el-switch
                  v-model="
                    formData.printers[index].config.showCalibrationBorder
                  "
                  active-value="true"
                  inactive-value="false"
                />
              </FormItem>
            </el-col>
          </el-row>
        </div>

        <FormButtons>
          <el-button
            type="primary"
            native-type="submit"
            @click.prevent="updateConfig"
          >
            {{ $t('systemConfig.save') }}
          </el-button>
        </FormButtons>
      </el-form>
    </div>
  </div>
</template>

<script>
  // import { mapGetters, mapActions } from 'vuex';

  import FormItem from '@/components/FormItem.vue';
  import FormButtons from '@/components/FormButtons.vue';
  import { configApi } from '@/api';

  const defaultPrinterConfig = {
    printerName: '',
    'printWidth-mm': '',
    'printHeight-mm': '',
    'labelWidth-mm': '',
    'labelHeight-mm': '',
    'labelMarginTop-mm': '',
    'labelMarginLeft-mm': '',
    'labelColSpacing-mm': '',
    showCalibrationBorder: false,
  };

  const defaultPrinterConfigKeys = Object.keys(defaultPrinterConfig);

  export default {
    name: 'SystemConfig',
    components: {
      FormItem,
      FormButtons,
    },
    data() {
      return {
        formData: {
          printers: [
            { type: 'materialLabels', config: { ...defaultPrinterConfig } },
            { type: 'sampleLabels', config: { ...defaultPrinterConfig } },
          ],
        },
      };
    },
    async created() {
      try {
        const sampleLabelsConfig = defaultPrinterConfigKeys.map((key) => ({
          key: `printers.sampleLabels.${key}`,
        }));
        const materialLabelsConfig = defaultPrinterConfigKeys.map((key) => ({
          key: `printers.materialLabels.${key}`,
        }));

        const currentConfig = await configApi.getConfig({
          or: [...sampleLabelsConfig, ...materialLabelsConfig],
        });
        const remoteKeys = Object.keys(currentConfig.data);
        remoteKeys.forEach((key) => {
          const printerType = key.split('.')[1]; // Gets printer type
          const printerIndex = this.formData.printers.findIndex(
            (p) => p.type === printerType
          );
          const configKey = key.split('.')[2]; // Gets config key
          // Populates form with remote data -- not very clean
          this.formData.printers[printerIndex].config[configKey] =
            currentConfig.data[key];
        });
      } catch (error) {
        this.$notify({
          showClose: true,
          type: 'error',
          message: error.response.data.error.message,
        });
      }
    },
    methods: {
      async updateConfig() {
        try {
          const materialLabelsConfig = this.formData.printers.find(
            (p) => p.type === 'materialLabels'
          ).config;
          const sampleLabelsConfig = this.formData.printers.find(
            (p) => p.type === 'sampleLabels'
          ).config;

          const data = {
            ...Object.keys(materialLabelsConfig).reduce(
              (acc, key) => ({
                ...acc,
                [`printers.materialLabels.${key}`]: materialLabelsConfig[key],
              }),
              {}
            ),
            ...Object.keys(sampleLabelsConfig).reduce(
              (acc, key) => ({
                ...acc,
                [`printers.sampleLabels.${key}`]: sampleLabelsConfig[key],
              }),
              {}
            ),
          };
          await configApi.updateConfig(data);

          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('systemConfig.saveSuccess'),
          });
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
    },
  };
</script>
